import { render, staticRenderFns } from "./Design-Detail.vue?vue&type=template&id=2fd623c0&scoped=true&"
import script from "./Design-Detail.vue?vue&type=script&lang=js&"
export * from "./Design-Detail.vue?vue&type=script&lang=js&"
import style0 from "./Design-Detail.vue?vue&type=style&index=0&id=2fd623c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd623c0",
  null
  
)

export default component.exports